import React, { useEffect, useState } from 'react';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const AMARELO = '#E6B400';
const LOCAIS = [
  'Torre A - Subsolo 1',
  'Torre A - Subsolo 2',
  'Torre B - Subsolo 1',
  'Torre B - Subsolo 2',
  'Torre C - Subsolo 1',
  'Torre C - Subsolo 2'
];

const reais = (valor) => Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const dataBR = (iso) => {
  if (!iso) return '';
  const [ano, mes, dia] = String(iso).slice(0, 10).split('-');
  return dia ? `${dia}/${mes}/${ano}` : '';
};

const botao = {
  background: AMARELO,
  border: 0,
  borderRadius: 24,
  padding: '12px 18px',
  fontWeight: 700,
  cursor: 'pointer'
};

const Garagens = () => {
  const { user } = useAuth();
  const administrador = user?.tipo === 'administrador' || user?.usuario_tipo === 'administrador';
  const [aba, setAba] = useState('disponiveis');
  const [vagas, setVagas] = useState([]);
  const [tela, setTela] = useState('lista');
  const [vaga, setVaga] = useState(null);
  const [reserva, setReserva] = useState(null);
  const [conta, setConta] = useState(null);
  const [erro, setErro] = useState('');
  const [form, setForm] = useState({
    numero: '', localizacao: LOCAIS[0], valor_diaria: '', data_inicio: '', data_fim: '',
    coberta: false, descricao: '', pix_tipo: 'cpf', pix_chave: '', foto_base64: null, foto: null
  });
  const [periodo, setPeriodo] = useState({ data_inicio: '', data_fim: '' });

  const carregar = async (qual = aba) => {
    const resposta = await api.get('/garagens/vagas', { params: { aba: qual === 'minhas' ? 'minhas' : 'disponiveis' } });
    setVagas(resposta.data?.data || []);
  };

  useEffect(() => {
    if (administrador) carregar().catch(() => setVagas([]));
  }, [administrador, aba]);

  if (!administrador) {
    return <div className="p-6 text-red-600">Disponível somente para o administrador.</div>;
  }

  const abrirForm = (atual) => {
    setErro('');
    setForm(atual ? {
      ...atual,
      valor_diaria: atual.valor_diaria,
      foto_base64: null
    } : {
      numero: '', localizacao: LOCAIS[0], valor_diaria: '', data_inicio: '', data_fim: '',
      coberta: false, descricao: '', pix_tipo: 'cpf', pix_chave: '', foto_base64: null, foto: null
    });
    setTela('form');
  };

  const lerFoto = (arquivo) => {
    if (!arquivo) return;
    const leitor = new FileReader();
    leitor.onload = () => setForm((atual) => ({ ...atual, foto: leitor.result, foto_base64: String(leitor.result).split(',')[1] }));
    leitor.readAsDataURL(arquivo);
  };

  const salvar = async (evento) => {
    evento.preventDefault();
    setErro('');
    try {
      const corpo = { ...form, valor_diaria: Number(String(form.valor_diaria).replace(',', '.')) };
      if (form.id) await api.put(`/garagens/vagas/${form.id}`, corpo);
      else await api.post('/garagens/vagas', corpo);
      setTela('lista');
      setAba('minhas');
      await carregar('minhas');
    } catch (error) {
      setErro(error.response?.data?.message || 'Erro ao salvar a vaga.');
    }
  };

  const abrirDetalhe = async (id) => {
    const resposta = await api.get(`/garagens/vagas/${id}`);
    setVaga(resposta.data.data);
    setPeriodo({ data_inicio: resposta.data.data.data_inicio, data_fim: resposta.data.data.data_fim });
    setTela('detalhe');
  };

  const simular = async (datas) => {
    const resposta = await api.post('/garagens/reservas/simular', { vaga_id: vaga.id, ...datas });
    setConta(resposta.data.data);
  };

  const reservar = async () => {
    setErro('');
    try {
      const resposta = await api.post('/garagens/reservas', { vaga_id: vaga.id, ...periodo });
      const pagamento = await api.get(`/garagens/reservas/${resposta.data.data.id}`);
      setReserva(pagamento.data.data);
      setTela('pagamento');
    } catch (error) {
      setErro(error.response?.data?.message || 'Não foi possível reservar.');
    }
  };

  const confirmar = async () => {
    const resposta = await api.post(`/garagens/reservas/${reserva.id}/confirmar`);
    setReserva(resposta.data.data);
    setTela('confirmada');
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="flex gap-6 border-b mb-4">
        {['disponiveis', 'minhas'].map((item) => (
          <button key={item} className="pb-2" style={{ fontWeight: aba === item ? 700 : 400, borderBottom: aba === item ? `3px solid ${AMARELO}` : '3px solid transparent' }} onClick={() => { setAba(item); setTela('lista'); }}>
            {item === 'disponiveis' ? 'Disponíveis' : 'Minhas vagas'}
          </button>
        ))}
      </div>
      {erro && <p className="text-red-600 mb-3">{erro}</p>}

      {tela === 'lista' && (
        <div>
          {aba === 'disponiveis' && <button style={botao} onClick={() => abrirForm(null)}>+ Disponibilizar minha vaga</button>}
          <div className="mt-4 space-y-3">
            {vagas.map((item) => (
              <button key={item.id} className="w-full text-left bg-white rounded-xl shadow p-3 flex gap-3" onClick={() => abrirDetalhe(item.id)}>
                {item.foto ? <img src={item.foto} alt="" className="w-24 h-16 object-cover rounded-lg" /> : <div className="w-24 h-16 bg-gray-200 rounded-lg" />}
                <div>
                  <div className="font-semibold">Vaga {item.numero}</div>
                  <div className="text-sm text-gray-600">{item.localizacao}</div>
                  <div>{reais(item.valor_diaria)} / diária</div>
                  <div className="text-xs text-gray-500">Disponível {dataBR(item.data_inicio)} a {dataBR(item.data_fim)}</div>
                </div>
              </button>
            ))}
            {vagas.length === 0 && <p className="text-gray-500">Nenhuma vaga nesta lista.</p>}
          </div>
        </div>
      )}

      {tela === 'form' && (
        <form onSubmit={salvar} className="bg-white rounded-xl shadow p-4 space-y-3">
          <h2 className="text-lg font-semibold">{form.id ? 'Editar vaga' : 'Disponibilizar vaga'}</h2>
          <input className="w-full border rounded px-3 py-2" placeholder="Número da vaga" value={form.numero} onChange={(e) => setForm({ ...form, numero: e.target.value })} />
          <select className="w-full border rounded px-3 py-2" value={form.localizacao} onChange={(e) => setForm({ ...form, localizacao: e.target.value })}>
            {LOCAIS.map((local) => <option key={local}>{local}</option>)}
          </select>
          <input className="w-full border rounded px-3 py-2" placeholder="Valor da diária" value={form.valor_diaria} onChange={(e) => setForm({ ...form, valor_diaria: e.target.value })} />
          <div className="grid grid-cols-2 gap-2">
            <input type="date" className="border rounded px-3 py-2" value={form.data_inicio || ''} onChange={(e) => setForm({ ...form, data_inicio: e.target.value })} />
            <input type="date" className="border rounded px-3 py-2" value={form.data_fim || ''} onChange={(e) => setForm({ ...form, data_fim: e.target.value })} />
          </div>
          <select className="w-full border rounded px-3 py-2" value={form.pix_tipo} onChange={(e) => setForm({ ...form, pix_tipo: e.target.value })}>
            <option value="cpf">CPF</option>
            <option value="email">E-mail</option>
            <option value="telefone">Telefone</option>
            <option value="aleatoria">Chave aleatória</option>
          </select>
          <input className="w-full border rounded px-3 py-2" placeholder="Chave Pix" value={form.pix_chave} onChange={(e) => setForm({ ...form, pix_chave: e.target.value })} />
          <p className="text-xs text-gray-500">Seus dados serão utilizados apenas para recebimento dos valores das locações.</p>
          <label className="flex gap-2 text-sm"><input type="checkbox" checked={!!form.coberta} onChange={(e) => setForm({ ...form, coberta: e.target.checked })} /> Vaga coberta</label>
          <textarea className="w-full border rounded px-3 py-2" placeholder="Descrição" value={form.descricao || ''} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
          <input type="file" accept="image/*" onChange={(e) => lerFoto(e.target.files[0])} />
          {form.foto && <img src={form.foto} alt="" className="h-32 rounded-lg object-cover" />}
          <div className="flex gap-2">
            <button style={botao} type="submit">Salvar vaga</button>
            <button type="button" className="px-4" onClick={() => setTela('lista')}>Cancelar</button>
          </div>
        </form>
      )}

      {tela === 'detalhe' && vaga && (
        <div className="bg-white rounded-xl shadow overflow-hidden">
          {vaga.foto && <img src={vaga.foto} alt="" className="w-full h-52 object-cover" />}
          <div className="p-4">
            <h2 className="text-2xl font-semibold">Vaga {vaga.numero}</h2>
            <p>{vaga.localizacao}</p>
            <p className="font-semibold">{reais(vaga.valor_diaria)} / diária</p>
            <p className="text-sm text-gray-500">Disponível {dataBR(vaga.data_inicio)} a {dataBR(vaga.data_fim)}</p>
            <p className="mt-2">{vaga.coberta ? 'Vaga coberta' : 'Vaga descoberta'}</p>
            {vaga.descricao && <p className="mt-3">{vaga.descricao}</p>}
            <p className="mt-4 text-sm text-gray-500">Proprietário</p>
            <p className="font-semibold">{vaga.proprietario_nome}</p>
            <div className="flex gap-2 mt-4">
              <button style={botao} onClick={() => { setTela('reservar'); simular(periodo).catch(() => setConta(null)); }}>Reservar vaga</button>
              <button className="border rounded-full px-4" onClick={() => abrirForm(vaga)}>Editar</button>
              <button className="bg-red-500 text-white rounded-full px-4" onClick={async () => { await api.put(`/garagens/vagas/${vaga.id}/desativar`); setTela('lista'); carregar(); }}>Desativar</button>
            </div>
          </div>
        </div>
      )}

      {tela === 'reservar' && vaga && (
        <div className="bg-white rounded-xl shadow p-4 space-y-3">
          <h2 className="text-lg font-semibold">Reservar vaga {vaga.numero}</h2>
          <div className="grid grid-cols-2 gap-2">
            <input type="date" className="border rounded px-3 py-2" value={periodo.data_inicio} onChange={(e) => {
              const datas = { ...periodo, data_inicio: e.target.value };
              setPeriodo(datas);
              simular(datas).catch(() => setConta(null));
            }} />
            <input type="date" className="border rounded px-3 py-2" value={periodo.data_fim} onChange={(e) => {
              const datas = { ...periodo, data_fim: e.target.value };
              setPeriodo(datas);
              simular(datas).catch(() => setConta(null));
            }} />
          </div>
          {conta && (
            <div className="text-sm space-y-1">
              <p>Diárias: {conta.dias}</p>
              <p>Valor da locação: {reais(conta.valor_locacao)}</p>
              <p>Taxa de serviço Síndico ON ({conta.taxa_percentual}%): {reais(conta.taxa_valor)}</p>
              <p className="font-semibold">Total da operação: {reais(conta.valor_total)}</p>
            </div>
          )}
          <button style={botao} onClick={reservar} disabled={!conta}>Continuar para pagamento</button>
        </div>
      )}

      {tela === 'pagamento' && reserva && (
        <div className="bg-white rounded-xl shadow p-4">
          <h2 className="text-lg font-semibold">Pagamento via Pix</h2>
          <p className="mt-3">Locação da vaga: {reais(reserva.valor_locacao)}</p>
          <p>Taxa Síndico ON ({reserva.taxa_percentual}%): {reais(reserva.taxa_valor)}</p>
          <p className="font-semibold text-lg">Total a pagar: {reais(reserva.valor_total)}</p>
          <div className="bg-green-50 rounded-lg p-3 my-3 text-sm">
            Pagamento único via Pix. O valor será dividido: {reais(reserva.valor_locacao)} para o proprietário e {reais(reserva.taxa_valor)} para o Síndico ON.
          </div>
          {reserva.qr_code && <img src={reserva.qr_code} alt="QR Code Pix" className="mx-auto w-56 h-56" />}
          <p className="text-center text-sm mt-2">Chave: {reserva.pix_chave}</p>
          <div className="flex gap-2 justify-center mt-4">
            <button style={botao} onClick={() => { navigator.clipboard.writeText(reserva.pix_chave); setTela('processando'); }}>Pagar {reais(reserva.valor_total)}</button>
            <button className="border rounded-full px-4" onClick={() => navigator.clipboard.writeText(reserva.pix_chave)}>Copiar chave Pix</button>
          </div>
        </div>
      )}

      {tela === 'processando' && (
        <div className="bg-white rounded-xl shadow p-8 text-center">
          <h2 className="text-xl font-semibold">Aguardando confirmação do pagamento</h2>
          <p className="text-gray-600 mt-3">Assim que o pagamento for confirmado, a reserva será validada automaticamente e o proprietário será notificado.</p>
          <button style={{ ...botao, marginTop: 20 }} onClick={confirmar}>Confirmar pagamento</button>
          <button className="block mx-auto mt-3 text-sm" onClick={() => setTela('lista')}>Voltar para o início</button>
        </div>
      )}

      {tela === 'confirmada' && reserva && (
        <div className="bg-white rounded-xl shadow p-6 text-center">
          <h2 className="text-xl font-semibold text-green-700">Reserva confirmada</h2>
          <p className="mt-2">Vaga {reserva.numero} · {reserva.localizacao}</p>
          <p>{dataBR(reserva.data_inicio)} a {dataBR(reserva.data_fim)}</p>
          <p className="mt-2">{reais(reserva.valor_locacao)} para o proprietário</p>
          <p>{reais(reserva.taxa_valor)} taxa Síndico ON</p>
          <p className="font-semibold text-lg">Total pago {reais(reserva.valor_total)}</p>
          <button className="mt-4" onClick={() => setTela('lista')}>Voltar</button>
        </div>
      )}
    </div>
  );
};

export default Garagens;
